import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Droplets, Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav(loc.state?.from || "/");
    } catch {
      toast.error("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-[#F3F4F1]">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2.5 mb-3">
            <div className="w-10 h-10 rounded-xl bg-[#064E3B] flex items-center justify-center">
              <Droplets className="w-5 h-5 text-white" />
            </div>
            <span className="font-display text-lg font-semibold">IV Therapy Finder</span>
          </div>
          <h1 className="font-display text-3xl font-semibold text-stone-900">Welcome back</h1>
          <p className="text-stone-600 mt-1 text-sm">Sign in to write reviews, save providers, and manage your listings.</p>
        </div>

        <form onSubmit={submit} className="bg-white rounded-2xl border border-stone-200 p-7 space-y-4 shadow-sm">
          <div>
            <Label className="text-xs uppercase font-semibold tracking-wider">Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div>
            <Label className="text-xs uppercase font-semibold tracking-wider">Password</Label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#064E3B] hover:bg-[#053d2f]" data-testid="login-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
          </Button>
          <div className="text-center pt-1">
            <Link to="/forgot-password" className="text-xs text-stone-500 hover:text-[#064E3B] hover:underline" data-testid="forgot-password-link">
              Forgot your password?
            </Link>
          </div>
          <p className="text-center text-sm text-stone-600 pt-2">
            No account? <Link to="/signup" className="text-[#064E3B] font-semibold hover:underline" data-testid="signup-link">Create one →</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
